import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const LoadboardValue = ({ children, className = "" }) => {
    return <div className={cn("text-cm-text-primary text-base/[25px] font-semibold", className)}>{children}</div>;
};
